<template>
  <div class="verify-container my-2">
    <div class="verify-bar" ref="bar">
      <div
        class="verify-bg"
        :class="{ 'no-transition': isMoving, 'is-success': isSuccess }"
        :style="{ width: bgWidth + 'px' }"
      ></div>
      <span class="verify-text" :class="{ 'success-text': isSuccess }">
        {{ isSuccess ? '验证通过' : '向右滑动验证' }}
      </span>
      <div
        class="verify-handler"
        :class="{ 'is-success': isSuccess }"
        :style="{ left: moveX + 'px' }"
        @mousedown.prevent="onStart"
        @touchstart.prevent="onStart"
      >
        <i v-if="!isSuccess">→</i>
        <i v-else>✓</i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const emit = defineEmits(['success'])

const moveX = ref(0)
const isSuccess = ref(false)
const isMoving = ref(false)
const bar = ref(null)
const handlerSize = ref(50)

let startX = 0

const bgWidth = computed(() => {
  if (isSuccess.value && bar.value) {
    return bar.value.offsetWidth
  }
  return moveX.value + handlerSize.value
})

const getMaxDistance = () => {
  if (!bar.value) return 0
  return bar.value.offsetWidth - handlerSize.value
}

const onStart = (e) => {
  if (isSuccess.value) return
  isMoving.value = true
  startX = e.clientX || e.touches[0].clientX

  window.addEventListener('mousemove', onMove)
  window.addEventListener('touchmove', onMove, { passive: false })
  window.addEventListener('mouseup', onEnd)
  window.addEventListener('touchend', onEnd)
}

const onMove = (e) => {
  if (!isMoving.value) return

  const currentX = e.clientX || (e.touches && e.touches[0].clientX)
  let distance = currentX - startX
  const maxDistance = getMaxDistance()

  if (distance < 0) distance = 0
  if (distance >= maxDistance) {
    distance = maxDistance
    confirmSuccess()
  }
  moveX.value = distance
}

const onEnd = () => {
  if (!isMoving.value) return
  isMoving.value = false

  if (!isSuccess.value) {
    moveX.value = 0
  }

  window.removeEventListener('mousemove', onMove)
  window.removeEventListener('touchmove', onMove)
  window.removeEventListener('mouseup', onEnd)
  window.removeEventListener('touchend', onEnd)
}

const confirmSuccess = () => {
  isSuccess.value = true
  isMoving.value = false
  moveX.value = getMaxDistance()
  emit('success')
}

onMounted(() => {
  if (bar.value) {
    handlerSize.value = bar.value.offsetHeight
  }
})

onUnmounted(() => {
  window.removeEventListener('mousemove', onMove)
  window.removeEventListener('touchmove', onMove)
  window.removeEventListener('mouseup', onEnd)
  window.removeEventListener('touchend', onEnd)
})
</script>

<style scoped>
.verify-container {
  width: 100%;
  user-select: none;
}

/* 与帐号输入框一致：rounded-full、白底、shadow-lg、border */
.verify-bar {
  position: relative;
  width: 100%;
  height: 50px;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}

.verify-bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #86efac;
  border-radius: 9999px;
  z-index: 1;
  pointer-events: none;
  transition: width 0.3s ease;
}

.verify-bg.no-transition {
  transition: none;
}

.verify-bg.is-success {
  background-color: #22c55e;
}

.verify-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #9ca3af;
  z-index: 2;
  pointer-events: none;
}

.success-text {
  color: #fff;
}

/* 圆形绿色滑动按钮，高度与滑条一致 */
.verify-handler {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  background: #22c55e;
  border-radius: 50%;
  border: none;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  z-index: 3;
  color: #fff;
  box-shadow: 0 4px 8px rgba(34, 197, 94, 0.35);
  transition: background-color 0.2s ease;
}

.verify-handler:active {
  cursor: grabbing;
  background: #16a34a;
}

.verify-handler.is-success {
  cursor: default;
  background: #16a34a;
}
</style>
